import { Role } from 'dashboard/models/role';
import Action from 'lib/interfaces/Action';
import { PaginationParams } from 'lib/interfaces/api';

interface RolesPayload {
  roles?: Role[];
  paginationParams?: PaginationParams;
}

export interface RolesFilterParams {
  omni?: string;
}

interface RolesFiltersPayload {
  filters: RolesFilterParams;
}

interface CurrentPagePayload {
  currentPage: number;
}

interface PageSizePayload {
  pageSize: number;
}

export type RolesActions =
  | Action<RolesActionType.SetRoles, RolesPayload>
  | Action<RolesActionType.SetAllRoles, RolesPayload>
  | Action<RolesActionType.SetFilters, RolesFiltersPayload>
  | Action<RolesActionType.SetPageSize, PageSizePayload>
  | Action<RolesActionType.SetCurrentPage, CurrentPagePayload>;

export enum RolesActionType {
  SetRoles = 'roles/SET_ROLES',
  SetAllRoles = 'roles/SET_ALL_ROLES',
  SetFilters = 'roles/SET_FILTERS',
  SetPageSize = 'roles/SET_PAGE_SIZE',
  SetCurrentPage = 'roles/SET_CURRENT_PAGE',
}

export function setRoles(roles: Role[], paginationParams?: PaginationParams) {
  return {
    payload: {
      roles,
      paginationParams,
    },
    type: RolesActionType.SetRoles,
  };
}

export function setAllRoles(roles: Role[]) {
  return {
    payload: {
      roles,
    },
    type: RolesActionType.SetAllRoles,
  };
}

export function setCurrentPage(currentPage: number) {
  return {
    payload: {
      currentPage,
    },
    type: RolesActionType.SetCurrentPage,
  };
}

export function setPageSize(pageSize: number) {
  return {
    payload: {
      pageSize,
    },
    type: RolesActionType.SetPageSize,
  };
}

export function setFilters(filters: RolesFilterParams) {
  return {
    payload: {
      filters,
    },
    type: RolesActionType.SetFilters,
  };
}
